import React, { Component } from 'react';
import { connect } from 'react-redux'
import { getRandomCity, getNextCity, getPrevCity } from "../ducks/cities";
import { pageView } from "../helpers/analytics";
import PlaceView from "../components/place/place"

class Place extends Component {
  componentDidMount () {
    this.props.getRandomCity()
    pageView(`/place`)
  }

  render () {
    const { isOpen } = this.props.menu

    return (
      <div className={`place ${isOpen ? 'blurred' : ''}`} >
        { this.props.city ? <PlaceView city = {this.props.city} /> : null }
      </div>
    )
  }
}

export default connect(
  (state) => {
    return {
      city: state.city,
      menu: state.menu
    }
  },
  { getRandomCity, getNextCity, getPrevCity }
)(Place)


// WEBPACK FOOTER //
// ./src/routes/Place.js